import {
  required,
  helpers,
  numeric,
  requiredIf
} from 'vuelidate/lib/validators';

export const fiveNumbers = helpers.regex('fiveNumbers', /^[0-9]{5}$/);
export const nineNumbers = helpers.regex('nineNumbers', /^[0-9]{9}$/);
export const telNumber = helpers.regex(
  'telNumber',
  /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/
);
export const mail = helpers.regex(
  'mail',
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const bookingValidation = {
  id: { required },
  billTo: { required },
  billToName: { required },
  shippingLine: { required },
  cutOff: { required },
  freeDays: { required, numeric },
  deliveryLocation: { required },
  returnLocation: { required },
  returnLocationName: { required },
  containers: {
    $each: {
      size: {
        required: requiredIf(field => field.type || field.total)
      },
      type: {
        required: requiredIf(field => field.total || field.size)
      },
      total: {
        required: requiredIf(field => field.type || field.size)
      },
      used: {}
    }
  },
  erd: {
    max: (value, form) => {
      if (value === 'Invalid date' || !value) {
        return true;
      }

      const valueNumber = Number(value);
      const cutOff = Number(form.cutOff);

      if (isNaN(valueNumber) || isNaN(cutOff)) {
        return true;
      }

      return valueNumber <= cutOff;
    }
  }
};

export const bookingData = {
  id: null,
  billTo: null,
  billToName: '',
  shippingLine: null,
  vessel: null,
  freeDays: null,
  erd: null,
  cutOff: null,
  commodity: null,
  pulloutLocation: null,
  pulloutLocationName: null,
  deliveryLocation: null,
  deliveryLocationName: null,
  returnLocation: null,
  returnLocationName: null,
  active: true,
  containers: [
    {
      size: '',
      type: '',
      total: '',
      used: null,
      balance: null
    },
    {
      size: '',
      type: '',
      total: '',
      used: null,
      balance: null
    },
    {
      size: '',
      type: '',
      total: '',
      used: null,
      balance: null
    }
  ],
  files: [
    {
      category: 'DETAILS',
      documentName: '',
      filename: '',
      file: '',
      tempS3FileName: '',
      tempS3PreSignedUrl: ''
    }
  ]
};
